import React from "react";
import { Modal } from "@mui/material";
import strings from "../../../../locales/ro.json";
import PopUpResponseButton from "../../../../components/Buttons/PopUpResponseButton/PopUpResponseButton";
import "./SendResultsModal.css";

const s = strings.admin.contacting.sendResults;

const REASON_LABELS = {
  invalid_phone: s.reasonInvalidPhone,
  not_on_whatsapp: s.reasonNotOnWhatsapp,
  client_disconnected: "Conexiune pierdută",
};

const SendResultsModal = ({ isOpen, results, onClose }) => {
  if (!results || results.length === 0) return null;

  const successCount = results.filter((r) => r.sent).length;
  const failCount = results.length - successCount;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="sr-overlay" onClick={onClose}>
        <div className="sr-container" onClick={(e) => e.stopPropagation()}>
          <div className="sr-header">
            <h2 className="sr-title">{s.title}</h2>
          </div>

          <div className="sr-summary">
            <div className="sr-summary-item sr-success">
              <span className="sr-summary-count">{successCount}</span>
              <span className="sr-summary-label">{s.sentLabel}</span>
            </div>
            <div className="sr-summary-divider" />
            <div className="sr-summary-item sr-fail">
              <span className="sr-summary-count">{failCount}</span>
              <span className="sr-summary-label">{s.failedLabel}</span>
            </div>
          </div>

          <div className="sr-results-list">
            {results.map((result, index) => (
              <div
                key={index}
                className={`sr-result-item ${result.sent ? "sr-sent" : "sr-failed"}`}
              >
                <div className="sr-result-icon">
                  {result.sent ? "✓" : "✕"}
                </div>
                <div className="sr-result-info">
                  <span className="sr-result-name">
                    {result.name || s.unknownPhone}
                  </span>
                  {result.phone && (
                    <span className="sr-result-phone">
                      {result.phone}
                    </span>
                  )}
                  {!result.sent && (
                    <span className="sr-result-reason">
                      {REASON_LABELS[result.reason] || result.reason}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="sr-footer">
            <PopUpResponseButton
              type="yes"
              text={s.closeBtn}
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SendResultsModal;
